var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6,11.5c0.6-0.1,1.2-0.3,1.8-0.5c1.1-0.4,2.2-0.9,3.3-1.3c0.6-0.2,1.2-0.4,1.8-0.3C9,9.5,9.4,9.8,9.7,10.2 c0.4,0.4,0.6,1,0.8,1.5c0,0.1,0,0.2,0.1,0.1c0.1,0,0.1-0.1,0.1-0.2c0.2-0.8,0.2-1.6,0.2-2.4c0-0.1-0.1-0.3-0.1-0.4 C9.9,7.7,8.7,7,7.2,6.7C6,6.5,4.8,6.6,3.6,6.7c-0.1,0-0.1,0-0.2,0.1C3.1,8.5,2.4,10,1.6,11.5C1.6,11.4,1.6,11.5,1.6,11.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7,8.3C10.5,7.1,10,6,9.2,5C9.2,4.9,9.1,4.8,9,4.7C7.8,4,6.6,3.7,5.3,3.5c-0.4,0-0.9-0.1-1.3,0c-0.1,0-0.2,0-0.2,0.2 c0,0.7,0,1.4-0.2,2.1c0,0.2,0,0.2,0.2,0.2c0.7-0.1,1.3-0.1,2,0C7,6,8.2,6.3,9.2,6.9c0.5,0.3,1,0.7,1.3,1.2 C10.6,8.2,10.6,8.3,10.7,8.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4,4C6.9,2.4,5.1,1.2,3.3,0.2c0.1,0.5,0.3,1,0.3,1.4c0,0.2,0.1,0.5,0.1,0.7c0,0.3,0.1,0.3,0.4,0.3c1,0.1,2,0.3,2.9,0.7 C7.5,3.5,7.9,3.7,8.4,4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSail);
export default __webpack_public_path__ + "static/media/SAIL.a4b38dc2873487b7d8e60fc7c24e3af9.svg";
export { ForwardRef as ReactComponent };